import type { FallbackRender } from '@sentry/react'

import React from 'react'
import { RefreshCcwIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import crashImg from '@/shared/assets/img/svg/crashed_block_placeholder.svg'

import { Button } from '../ui/button'
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '../ui/empty'

type Props = React.ComponentProps<FallbackRender> & {
	className?: string
}
export function ErrorPageMessage({ className, ...props }: Props) {
	const { t } = useTranslation()

	return (
		<Empty className={className}>
			<EmptyHeader>
				<EmptyMedia>
					<img src={crashImg} alt='crash' className='max-h-80 p-3' />
				</EmptyMedia>
				<EmptyTitle>{t('fatal_error_title')}🐞</EmptyTitle>
				<EmptyDescription>{t('fatal_error_desc')}</EmptyDescription>
			</EmptyHeader>
			<EmptyContent>
				{!!props.resetError && (
					<Button onClick={() => props.resetError?.()}>
						{t('app.retry', { defaultValue: 'Retry' })}
					</Button>
				)}
				<Button onClick={() => window.location.reload()}>
					<RefreshCcwIcon />
					{t('app.refresh_the_page', { defaultValue: 'Refresh the page' })}
				</Button>
			</EmptyContent>
		</Empty>
	)
}
